import { Divider } from 'antd'
import UnknownErrorImg from '../../assets/images/UnknownErrorImg.svg'
import { ButtonGroup } from '../../components'
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../redux/store';
import { ErrorMessage, ErrorType } from '../../models/ErrorType';
import { clearError } from '../../redux/errorSlice';
import { isLoading } from '../../redux/loaderSlice';
import { selectFlowStep } from '../../redux/headerSlice';
import { StorageService } from '../../services/Storage';
import { REDIRECTION_URL } from '../../utils/constants';
import { EventMessageService } from '../../services/EventMessage';
import InsightService from '../../services/Insight';

export const UnknownError: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const errorType = useSelector((state: IRootState) => state.error.value);
  const pepperOne = useSelector((state: IRootState) => state.params.value.pepperOne);
  const [message, setMessage] = useState<ErrorMessage | undefined>(undefined);

  const quitProcess = () => {
    dispatch(clearError());
    InsightService.logTrace('ErrorPage', [
      { ErrorPage: true },
      { ActiveQuit: true },
    ]);
    StorageService.deleteStorage();
    if (pepperOne) {
      EventMessageService.sendMessageEvent('error');
    } else {
      window.location.href = REDIRECTION_URL;
    }
  }

  const retry = () => {
    dispatch(clearError());
    navigate(-1);
  }

  const selectMessage = () => {
    const error = errorType || StorageService.getError();
    switch (error) {
      case ErrorType.CONFIG_FAILED:
        setMessage({
          title: 'No se ha podido obtener una configuración',
          description: ''
        });
        break;
      case ErrorType.BANK_FAILED:
        setMessage({
          title: '¡Vaya! No hemos podido establecer la conexión con tu banco.',
          description: 'Inténtalo de nuevo'
        });
        break;
      case ErrorType.PLATFORM_FAILED:
        setMessage({
          title: '¡Vaya! Ha habido un problema al conectar con la plataforma.',
          description: 'Inténtalo de nuevo'
        });
        break;
      case ErrorType.AGGREGATION_FAILED:
        setMessage({
          title: '¡Vaya! No se ha podido completar la solicitud.',
          description: 'Inténtalo de nuevo'
        });
        break;
      case ErrorType.UNKNOWN:
      default:
        setMessage({
          title: 'Algo ha fallado...',
          description: 'En estos momentos no se ha podido completar el proceso de Banca Online'
        });
        break;
    }
  }

  useEffect(() => {
    selectMessage();
    dispatch(selectFlowStep(null));
    dispatch(isLoading(false));
  }, [])


  return (
    <div className='pepper-status-page pepper-page-padding' id='error'>
      <img src={UnknownErrorImg} alt='pepper-error'/>
      <div className='pepper-status-text-body'>
        <div className='pepper-title-center' id='configError'>{message?.title}</div>
        {message?.description && <>
          <div className='pepper-subtitle'>{message?.description}</div>
        </>}
      </div>
      <Divider className='pepper-status-page-divider' />
      <ButtonGroup continueMsg='Salir y terminar proceso' cancelMsg='Volver a intentar' handleOk={quitProcess} handleCancel={retry} />
    </div >
  )
}

